Object.defineProperty(exports, '__esModule', {
  value: true
});

// This is a magic string replaced by rollup

const SDK_VERSION = "8.55.0";
exports.SDK_VERSION = SDK_VERSION;